import React from 'react';
import { ContentProvider } from './context';
import BookingDate from './content/BookingDate';

const BookingDates = () => (
  <ContentProvider>
    <BookingDate />
  </ContentProvider>
);

export default BookingDates;
